import { useEffect } from "react";

/**
 * صفحة سياسة الخصوصية — إلزامية لتطبيق Google Play.
 * الرابط الرسمي: https://jumlaty.online/privacy
 * تحديث Feb 27, 2026.
 */
const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "سياسة الخصوصية · جملتي";
  }, []);

  return (
    <div dir="rtl" className="min-h-screen bg-[#FAFCFA] text-[#111814]">
      <div className="max-w-3xl mx-auto px-5 py-8">
        <div className="mb-6 flex items-center gap-3">
          <img src="/jumlaty-icon-192.png" alt="جملتي" className="w-14 h-14 rounded-2xl shadow" />
          <div>
            <h1 className="text-3xl font-black text-[#1E3A5F]">سياسة الخصوصية</h1>
            <p className="text-sm text-[#5C6E64]">آخر تحديث: 27 فبراير 2026</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-[#E4EBE6] p-6 space-y-5 leading-relaxed text-[15px]">
          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">1. من نحن</h2>
            <p>
              تطبيق <strong>جملتي (Jumlaty)</strong> هو منصة عراقية لبيع منتجات الجملة (المواد الغذائية والمنظفات وغيرها)
              للمحلات والزبائن المسجلين. يديره فريق جملتي في بغداد — العراق.
              للتواصل: <a href="mailto:mmujtabaa031@gmail.com" className="text-[#3B82F6] underline">mmujtabaa031@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">2. البيانات التي نجمعها</h2>
            <ul className="list-disc pr-5 space-y-1">
              <li><strong>الاسم ورقم الهاتف</strong> — لإنشاء الحساب والتواصل بشأن الطلبات.</li>
              <li><strong>اسم المحل (اختياري)</strong> — للمحلات فقط، لتسهيل التوصيل.</li>
              <li><strong>الموقع الجغرافي (اختياري)</strong> — نستخدمه فقط لإيصال طلباتك بواسطة السائق. يتم جمعه <em>فقط</em> عندما تضغط زر «حدّد موقعي» داخل التطبيق.</li>
              <li><strong>تاريخ الطلبات والمشتريات</strong> — لعرض سجل طلباتك وإدارة الفواتير.</li>
              <li><strong>رموز الدفع الإلكتروني (Firebase Cloud Messaging)</strong> — لإرسال إشعارات الحالة بالطلب.</li>
            </ul>
            <p className="mt-2">
              <strong>لا نجمع</strong>: كلمات المرور بشكل مقروء، أرقام البطاقات المصرفية، أو أي بيانات صحية أو حساسة.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">3. كيف نستخدم بياناتك</h2>
            <ul className="list-disc pr-5 space-y-1">
              <li>معالجة طلباتك وتوصيلها لعنوانك.</li>
              <li>التواصل معك بشأن حالة الطلب (تأكيد / في الطريق / تم التسليم).</li>
              <li>إرسال إشعارات ترويجية <em>فقط</em> إذا فعّلت هذا الخيار (قابل للإيقاف من إعدادات جوالك).</li>
              <li>تحسين تجربة التسوق وتخصيص العروض حسب سلوك الشراء.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">4. مشاركة البيانات</h2>
            <p>
              <strong>لا نبيع بياناتك ولا نشاركها مع أي طرف ثالث</strong> باستثناء:
            </p>
            <ul className="list-disc pr-5 space-y-1 mt-1">
              <li><strong>السائق</strong> يرى اسمك ورقم هاتفك وعنوان التوصيل فقط لغرض إيصال الطلب.</li>
              <li><strong>Google Firebase</strong> لخدمة الإشعارات (لا يمكنه الوصول لبياناتك الشخصية).</li>
              <li><strong>السلطات القانونية</strong> عند وجود طلب رسمي بموجب القانون العراقي.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">5. الأمان</h2>
            <p>
              كلمات المرور مشفّرة (bcrypt) عند التخزين. الاتصال بين التطبيق والخادم مشفّر عبر HTTPS/SSL.
              مفاتيح الوصول (JWT) لها مدة صلاحية محدودة.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">6. حقوقك</h2>
            <ul className="list-disc pr-5 space-y-1">
              <li><strong>عرض بياناتك</strong>: من «إدارة حسابي» في التطبيق.</li>
              <li><strong>تعديل بياناتك</strong>: من «إدارة حسابي».</li>
              <li>
                <strong>حذف حسابك وبياناتك بشكل نهائي</strong>: أرسل طلبك على
                {" "}<a href="mailto:mmujtabaa031@gmail.com" className="text-[#3B82F6] underline">mmujtabaa031@gmail.com</a>
                {" "}وسنحذف حسابك خلال 7 أيام عمل.
              </li>
              <li><strong>إيقاف الإشعارات</strong>: من إعدادات جوالك ← جملتي ← الإشعارات.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">7. الأطفال</h2>
            <p>
              التطبيق مخصص للأشخاص البالغين (18 سنة فأكثر). لا نجمع بيانات من الأطفال عن قصد.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">8. الاحتفاظ بالبيانات</h2>
            <p>
              نحتفظ ببياناتك ما دام حسابك نشطاً. عند طلب الحذف، تُحذف جميع البيانات باستثناء
              الفواتير والسجلات المطلوبة قانونياً (تُحفظ 5 سنوات لأغراض المحاسبة).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">9. تعديلات على السياسة</h2>
            <p>
              قد نحدّث هذه السياسة من وقت لآخر. سيتم إشعارك عبر التطبيق عند أي تغيير جوهري.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-black text-[#1E3A5F] mb-2">10. تواصل معنا</h2>
            <p>
              للأسئلة أو الشكاوى المتعلقة بالخصوصية:
              <br />
              📧 <a href="mailto:mmujtabaa031@gmail.com" className="text-[#3B82F6] underline">mmujtabaa031@gmail.com</a>
              <br />
              📍 بغداد — العراق
            </p>
          </section>
        </div>

        <p className="text-center text-xs text-[#5C6E64] mt-6">
          © 2026 جملتي (Jumlaty) — جميع الحقوق محفوظة
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
